import { useState } from "react";
import { Text } from "@primer/react";
import { AlertFillIcon, CheckCircleFillIcon, ChevronRightIcon, CircleIcon, XCircleFillIcon } from "@primer/octicons-react";
import { ExpansionSection } from "../ExpansionSection/ExpansionSection.jsx";
import "./ComplianceResultGroups.css";

const groups = [
  { key: "violation", label: "Violations", singular: "Violation" },
  { key: "warning", label: "Advisories", singular: "Advisory" },
  { key: "compliant", label: "Compliant", singular: "Compliant" }
];
const defaultExpandedGroups = ["violation", "warning"];

export function ComplianceResultGroups({ defaultExpanded = defaultExpandedGroups, empty, expandedEdge = false, findings, renderFinding }) {
  if (!findings.length) return <Text className="compliance-results-empty">{empty}</Text>;
  return <div className="compliance-result-groups">{groups.map((group) => {
    const groupFindings = findings.filter((finding) => finding.tone === group.key);
    if (!groupFindings.length) return null;
    return <ComplianceResultGroup expandedEdge={expandedEdge} findings={groupFindings} group={group} initiallyExpanded={defaultExpanded.includes(group.key)} key={group.key} renderFinding={renderFinding} />;
  })}</div>;
}

function ComplianceResultGroup({ expandedEdge, findings, group, initiallyExpanded, renderFinding }) {
  const [expanded, setExpanded] = useState(initiallyExpanded);
  const label = findings.length === 1 ? group.singular : group.label;
  const content = <>
    <header><button aria-expanded={expanded} type="button" onClick={() => setExpanded((current) => !current)}><ChevronRightIcon aria-hidden="true" /><strong>{findings.length} {label}</strong></button></header>
    {expanded ? <div>{findings.map(renderFinding)}</div> : null}
  </>;
  const className = `compliance-result-group ${group.key}`;
  if (expandedEdge) return <ExpansionSection className={className} expanded={expanded}>{content}</ExpansionSection>;
  return <section className={`${className}${expanded ? " expanded" : ""}`}>{content}</section>;
}

export function complianceResultTone(status) {
  if (status === "non-compliant") return "violation";
  if (status === "warning") return "warning";
  return "compliant";
}

export function ComplianceResultState({ status }) {
  const presentation = status === "non-compliant"
    ? { Icon: XCircleFillIcon, label: "Violation", tone: "violation" }
    : status === "warning"
      ? { Icon: AlertFillIcon, label: "Advisory", tone: "warning" }
      : status === "not-evaluated"
        ? { Icon: CircleIcon, label: "Not evaluated", tone: "not-evaluated" }
        : { Icon: CheckCircleFillIcon, label: "Compliant", tone: "compliant" };
  const { Icon, label, tone } = presentation;
  return <span aria-label={label} className={`compliance-result-state ${tone}`} role="img"><Icon aria-hidden="true" size={24} /></span>;
}
